import { useEffect, useState } from "react"
import { createItem, deleteItem, fetchUserList, updateItem } from "../api/lists"
import type { GiftList, ItemInput } from "../types"

export function useOwnedList(userId: number | undefined) {
  const [list, setList] = useState<GiftList | null>(null)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    let active = true
    if (userId === undefined) return
    setLoading(true)
    setList(null)
    void fetchUserList(userId)
      .then(value => { if (active) setList(value) })
      .catch(() => { if (active) setList(null) })
      .finally(() => { if (active) setLoading(false) })
    return () => { active = false }
  }, [userId])

  async function add(input: ItemInput) {
    if (!list) throw new Error("List is not available")
    const item = await createItem(list.id, input)
    setList(current => current?.id === list.id ? { ...current, items: [...current.items, item] } : current)
    return item
  }

  async function update(id: number, input: ItemInput) {
    if (!list) throw new Error("List is not available")
    const item = await updateItem(list.id, id, input)
    setList(current => current?.id === list.id ? { ...current, items: current.items.map(existing => existing.id === id ? item : existing) } : current)
  }

  async function remove(id: number) {
    if (!list) throw new Error("List is not available")
    await deleteItem(list.id, id)
    setList(current => current?.id === list.id ? { ...current, items: current.items.filter(item => item.id !== id) } : current)
  }

  return { list, loading, add, update, remove }
}
